// // TOBE removed once  webpack Module Federation is stable

export async function loadRemoteComponent({ url, scope, module }) {
  await new Promise((resolve, reject) => {
    if (window[scope]) return resolve();

    const script = document.createElement('script');
    script.src = url;
    script.type = 'text/javascript';
    script.async = true;

    script.onload = () => resolve();
    script.onerror = () => reject(new Error(`Failed to load remote: ${url}`));

    document.head.appendChild(script);
  });

  await __webpack_init_sharing__('default');
  const container = window[scope];
  await container.init(__webpack_share_scopes__.default);

  const factory = await container.get(module);
  const Module = factory();
  return Module;
}

